module.exports = __webpack_public_path__ + "img/头图.c9890f01.png";